import styled from "styled-components";

export const Main = styled.main``;

export const MainInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 50rem;
  margin: 2rem auto;
`;
